module.exports = __webpack_public_path__ + "media/images/email/ic_gmail-127c48941f3b6cb492df1b41cc2aba40.svg";